angular.module('bbl.module.profile', [
  'bbl.services',
  'bbl.module.profile.routing',
  'bbl.module.profile.controller',
]);

require('./profile.style.less');
require('./profile.controller');
require('./profile.routing');



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/profile/profile.module.js
 ** module id = 354
 ** module chunks = 0
 **/